export const Breakpoint = {
	s: 400,
	m: 800,
	l: 930,
	xl: 1200,
}

export const GalleryMargin = 2

